// extracted by mini-css-extract-plugin
export var carrierIconPlaceholder = "_88-1";
export var dragButton = "_88-5";
export var sortableCell = "_88-4";
export var sortableNameCell = "_88-3";
export var sortableRow = "_88-0";
export var tableHeader = "_88-6";
export var tableHeaderWithCardHeader = "_88-7";
export var weightInputRow = "_88-2";